import * as angular from 'angular';
import * as angularTranslate from 'angular-translate';

import { mediaModel } from '../models/media';

import goAttachmentComponent from './attachment/attachment.component';
import goAttachmentsComponent from './attachments/attachments.component';

import './style.less';

// TODO: fix circular dependency.
// Until then, we need to import directly to force side-effect of angular module
// loading. If we leave the `fooModule from` part, webpack will use tree-shaking
// and the module will not be loaded.

import /*{ goModal } from*/ '../modals';
import /*{ universalMediaChooserModule } from*/ '../universal-media-chooser';
import /*{ mediaThumbnailModule } from*/ '../media-thumbnail';
import { attachmentServiceModule } from 'go-modules/services/attachment';

export const goAttachment = angular.module('go.attachment', [
	angularTranslate,
	attachmentServiceModule,
	mediaModel,

	// TODO: use module strings directly until circular dependency is fixed
	'go.modal',
	'universal-media-chooser',
	'go.mediaThumbnail'
])
	.component('goAttachment', goAttachmentComponent)
	.component('goAttachments', goAttachmentsComponent)
	.name;
